var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<tr>\n    <td>\n        <strong>'+
((__t=( quote.symbol ))==null?'':__t)+
'</strong>\n    </td>\n    <td>\n        <div class="quote-area">\n            <dl class="align-right">\n                <dt class="quote-title-bid">'+
((__t=( quote.titleBid ))==null?'':__t)+
'</dt>\n                <dd>'+
((__t=( quote.bid ))==null?'':__t)+
'</dd>\n            </dl>\n            <div>\n                '+
((__t=( quote.spread ))==null?'':__t)+
'\n            </div>\n            <dl class="align-left">\n                <dt class="quote-title-ask">'+
((__t=( quote.titleAsk ))==null?'':__t)+
'</dt>\n                <dd>'+
((__t=( quote.ask ))==null?'':__t)+
'</dd>\n            </dl>\n        </div>\n    </td>\n    <td class="">$'+
((__t=( quote.commission ))==null?'':__t)+
'</td>\n    <td class="">'+
((__t=( quote.margin ))==null?'':__t)+
'%</td>\n    <td class="">'+
((__t=( quote.swap.long ))==null?'':__t)+
'</td>\n    <td class="">'+
((__t=( quote.swap.short ))==null?'':__t)+
'</td>\n    <td class="">'+
((__t=( quote.stopLevel ))==null?'':__t)+
'</td>\n</tr>';
}
return __p;
};
